import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType, DBImportPreview } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (importType: string, token: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
  if (!token) {
    throw new Error('`token` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  token: string;
};

type Response = DBImportPreview;

export const getImportPreview = async (
  scope: RequestScope,
  { importType, token }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType, token);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`import_preview/${importType}/${token}`, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
